<template>
  <div class="addMessage">
    <div class="title">选择企业</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
      ><div class="selectBox">
        <el-form-item label="选择地区：">
          <el-select v-model="county" placeholder="所属地区">
            <el-option
              v-for="item in areaList"
              :key="item.county"
              :label="item.county"
              :value="item.county"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择标签：">
          <el-cascader
            placeholder="企业标签"
            v-model="entLabel"
            :options="labelList"
            :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'id',
              children: 'children',
              multiple: true,
              checkStrictly: true,
              emitPath: false
            }"
            filterable
            :multiline="false"
            clearable
            :show-all-levels="false"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item label="添加企业：">
          <div class="addEnt-box">
            <div>
              <el-select
                v-model="entName"
                filterable
                :filter-method="filterVmModel"
                placeholder="请选择"
                @change="addEnt"
                v-el-select-loadmore="loadmore"
                clearable
              >
                <el-option
                  v-for="(item, index) in searchEntList"
                  :label="item.entName"
                  :value="item.entName"
                  :key="index"
                ></el-option>
              </el-select>
              <div class="select-btn">
                <el-button @click="addSmsEntTemplate(1)">添加</el-button>
                <el-button @click="addSmsEntTemplate(2)" :loading="loading"
                  >一键添加</el-button
                >
              </div>
            </div>
            <div class="entList-box">
              已选择<span class="highlight">{{ selectEntNum }}</span
              >家企业
              <div
                class="entList-box-item"
                v-infinite-scroll="loadEntList"
                v-loading="loading"
                infinite-scroll-immediate="false"
              >
                <div
                  class="entList-item"
                  v-for="(item, index) in entList"
                  :key="index"
                >
                  <div>{{ item.entName }}</div>
                  <div @click="deleteEntItem(item, index)">X</div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
      <el-form-item label="接收人：" prop="receiver">
        <el-checkbox-group v-model="ruleForm.receiver">
          <el-checkbox
            :label="item.label"
            name="type"
            v-for="(item, index) in receiverList"
            :key="index"
          ></el-checkbox>
        </el-checkbox-group>
        <!-- <div v-if="noContactEnt.length">
          {{ noContactEnt.join(',') }}
        </div>
        <div v-if="!noContactEnt.length && ruleForm.receiver.length">
          暂无联系人
        </div> -->
      </el-form-item>
      <el-form-item>
        <el-button @click="goBackList()">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="selectLoading"
          >确 定</el-button
        >
      </el-form-item>

      <div class="problemBox">
        <div class="problemTitle">常见问题：</div>
        <div>1.如何推送？</div>
        <div class="content">
          先填写消息内容，并选择好推送渠道，再选择要推送的企业。消息新建完成后无法修改，请确认好后再选择企业
        </div>
        <div>2.为什么有些企业会发送失败？</div>
        <div class="content">
          通过企业联系人的手机号码等用户信息发送对应渠道的消息。若发送失败请检查该用户是否存在该企业，以及信息是否填写正确。若要发送微信公众号消息，则需要先关注微信号
        </div>
        <div>3.如何发送钉钉群消息？</div>
        <div class="content">
          请先建立钉钉群并开通群智能机器人，在钉钉机器人管理页面添加机器人的Webhook，在此页面选择要发送的群。若发送失败请检查webhook是否正确
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  getAllDictLabel,
  findEntList,
  addSmsEntTemp,
  smsEntTempPage,
  deleteSmsEntTemp,
  getMapProcess
} from '@api/yardPolicy/policyManagement/index'
import { addSmsEnt, cancelSmsEntTemp } from '@api/corporateInteraction/examine'
import { categoryDictList } from '@/common/api/corporateInteraction/messageTemplate'
import { getArea } from '@api/common'
import { isConnectList } from '@api/corporateInteraction/enterprise'
export default {
  name: 'PolicyMessagePush',
  directives: {
    // 计算是否滚动到最下面
    'el-select-loadmore': {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          '.el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          const condition =
            Math.round(this.scrollHeight - this.scrollTop) <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  data() {
    return {
      receiverList: [
        {
          label: '法人'
        },
        {
          label: '经办人'
        },
        {
          label: '财务'
        },
        {
          label: '人事'
        },
        {
          label: '行政'
        }
      ],
      ruleForm: {
        receiver: []
      },
      // 消息模板列表
      messageTemplateList: [],
      rules: {
        receiver: [
          {
            required: true,
            type: 'array',
            message: '请选择接收人',
            trigger: 'change'
          }
        ]
      },
      categoryId: '', // 选择模板类别
      pageNum: 1,
      pageSize: 10,
      totalRecord: 0,
      searchEntList: [],
      entList: [],
      areaList: [], // 区域
      entLabel: '', // 企业标签
      labelList: [], // 标签列表
      smsTypeList: [], // 消息类别
      county: '', // 选择地区
      entName: '',
      creditCode: '',
      labelCodeStr: '',
      policyName: '', // 政策名称
      selectEntNum: 0,
      loading: false,
      selectLoading: false,
      timer: null,
      entGroupIndex: 0,
      groupSize: 0,
      filterText: null,
      type: 1, // 写死1，类型：1消息，2政策，具体问-雪见
      noContactEnt: [],
      entNames: [],
      submitSelect: false // 如果点击确定后，这个时候不需要去掉取消的接口
    }
  },
  watch: {
    entLabel() {
      this.findEntList()
    },
    county() {
      this.findEntList()
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.smsEntTempPage()
    this.init()
  },
  methods: {
    async init() {
      await this.getAreaList()
      await this.getEntLabel()
      this.findEntList()
    },
    goBackList() {
      this.$confirm('当前页面编辑信息不回被保存，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ name: 'messageManagement' })
      })
    },
    // 获取类别列表
    getCategoryList() {
      categoryDictList().then((res) => {
        if (res.data.code == '0000') {
          this.smsTypeList = res.data.data
        }
      })
    },
    // 地区
    getAreaList() {
      return new Promise((resolve, reject) => {
        getArea().then((res) => {
          if (res.data.code === '0000') {
            this.areaList = res.data.data
            resolve()
          }
        })
      })
    },
    // 企业标签
    getEntLabel() {
      return new Promise((resolve, reject) => {
        getAllDictLabel().then((res) => {
          if (res.data.code == '0000') {
            this.labelList = res.data.data
            resolve()
          }
        })
      })
    },
    // 查询不分页企业
    findEntList() {
      const params = {
        labelCodeStr: this.entLabel ? this.entLabel.join(',') : '',
        county: this.county
      }
      findEntList(params).then((res) => {
        if (res.data.code == '0000') {
          this.dataList = []
          for (var value of Object.values(res.data.data)) {
            this.dataList.push(value)
          }
          this.groupSize = this.dataList.length
          this.searchEntList = this.dataList[0]
        }
      })
    },
    filterVmModel(value) {
      this.searchEntList = []
      // 筛选数据
      if (value) {
        this.filterText = value
        Object.values(this.dataList).forEach((val, index) => {
          const list = val.filter((item) => {
            return item.entName && item.entName.indexOf(value) !== -1
          })
          console.log(list)
          list.forEach((element) => {
            this.searchEntList.push(element)
          })
        })
      } else {
        // 直接赋值会连续触发 loadmore 分页事件
        this.$nextTick(() => {
          this.searchEntList = this.dataList[0]
        })
      }
    },
    // 分页方法
    loadmore(firstTag) {
      if (!this.filterText) {
        if (!firstTag && this.entGroupIndex < this.groupSize) {
          this.entGroupIndex++
        }
        this.searchEntList = this.searchEntList.concat(
          this.dataList[this.entGroupIndex]
        )
      }
    },
    // 查询分页企业
    smsEntTempPage() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: this.type,
        relationId: this.id
      }
      smsEntTempPage(params).then((res) => {
        const { data, code, msg } = res.data
        if (code == '0000') {
          this.selectEntNum = data.total
          if (this.pageNum == 1) {
            this.entList = data.list
          } else {
            if (this.pageNum <= data.pages) {
              this.entList = data.list ? this.entList.concat(data.list) : []
            }
          }
        }
      })
    },
    // 添加、一键添加
    addSmsEntTemplate(type) {
      if (type == 1 && !this.entName) {
        return this.$message.warning('请选择需要添加的企业')
      }
      const data = {
        handleType: type,
        type: this.type,
        relationId: this.id,
        entName: this.entName,
        creditCode: this.creditCode,
        county: this.county, // 选择地区
        labelCodeStr: this.entLabel ? this.entLabel.join(',') : ''
      }
      addSmsEntTemp(data).then((res) => {
        if (res.data.code == '0000') {
          if (type == 1) {
            this.entName = ''
            this.smsEntTempPage()
          } else {
            setTimeout(() => {
              this.loading = true
              this.getMapProcess(res.data.data)
              this.timer = setInterval(this.getMapProcess, 3000, res.data.data)
            })
          }
        }
      })
    },
    getMapProcess(key) {
      const params = {
        key: key
      }
      getMapProcess(params).then((res) => {
        const { data, code, msg } = res.data
        const process = Number(data.process)
        if (process == 1) {
          clearInterval(this.timer)
          this.loading = false
          this.pageNum = 1
          this.smsEntTempPage()
        }
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addSelectEnt()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addSelectEnt() {
      this.selectLoading = true
      const data = {
        recipientList: this.ruleForm.receiver,
        relationId: this.id,
        type: this.type
      }
      addSmsEnt(data).then((res) => {
        if (res.data.code == '0000') {
          this.submitSelect = true
          this.selectLoading = false
          this.$message.success('新建成功！请等待审核')
          this.$router.push({ name: 'messageManagement' })
        } else {
          this.selectLoading = false
          this.entName = ''
          this.$message.error(res.data.msg)
        }
      })
    },
    // 无限加载企业列表
    loadEntList() {
      this.pageNum++
      this.smsEntTempPage()
    },
    // 删除选择的企业
    deleteEntItem(item, index) {
      deleteSmsEntTemp({ id: item.id }).then((res) => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          // this.entList.splice(index, 1)
          this.pageNum = 1
          this.smsEntTempPage()
        }
      })
    },
    // 添加企业，获取企业信息
    addEnt(data) {
      const index = this.searchEntList.findIndex((item) => item.entName == data)
      this.creditCode = this.searchEntList[index].creditCode
    },
    /** 勾选获取企业有无相关联系人 */
    onGetEntName(val) {
      this.entNames = []
      this.entList.forEach((ele) => {
        this.entNames.push(ele.entName)
      })

      let par = {
        entNames: this.entNames.join(','),
        recipients: val.join(',')
      }
      isConnectList(par).then((res) => {
        if (res.data.code == '0000') {
          this.noContactEnt = res.data.data || []
        }
      })
    },
    cancelSmsEntTemp() {
      const params = {
        type: this.type,
        relationId: this.id
      }
      cancelSmsEntTemp(params).then((res) => {
        if (res.data.code == '0000') {
          console.log(res.data.data)
        }
      })
    }
  },
  destroyed() {
    if (!this.submitSelect) {
      // 保证，确认提交成功后，不调取消接口
      this.cancelSmsEntTemp()
    }
  }
}
</script>

<style lang="scss" scoped>
.addMessage {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  &::-webkit-scrollbar-track-piece {
    background: rgba(211, 220, 230, 0.5);
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(211, 220, 230, 0.5);
    border-radius: 20px;
  }
  .title {
    font-size: 16px;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
  }
  .addEnt-box {
    width: 100%;
    display: flex;
    .select-btn {
      margin-top: 20px;
    }
    .entList-box {
      width: 50%;
      border: 1px solid #eee;
      margin-left: 20px;
      height: 250px;
      overflow-y: auto;
      border-radius: 3px;
      padding: 10px 15px;
      .highlight {
        color: #46a6ff;
        display: inline-block;
        padding: 6px;
      }
      &::-webkit-scrollbar-track-piece {
        background: #d3dce6;
      }

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(153, 169, 191, 0.5);
        border-radius: 20px;
      }

      .entList-item {
        height: 32px;
        line-height: 32px;
        background: #caeaff;
        color: #3399ff;
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        margin-bottom: 10px;
      }
    }
  }

  /deep/.el-form-item {
    margin-bottom: 20px;
  }
  /deep/.el-form {
    padding: 20px;
  }
  /deep/.el-form-item--medium .el-form-item__content {
    line-height: 32px;
  }
  /*  /deep/.el-alert,
  /deep/.el-input__inner,
  /deep/.el-select,
  /deep/.el-textarea__inner {
    width: 50%;
  } */
  /deep/.el-select,
  /deep/.el-cascader {
    .el-input__inner {
      width: 100%;
    }
  }
  .problemBox {
    background: rgba(250, 251, 252, 1);
    padding: 20px;
    border-radius: 2px;
    border: 1px solid rgba(228, 228, 228, 1);
    font-size: 14px;
    color: rgba(51, 51, 51, 0.95);
    line-height: 20px;
    .problemTitle {
      margin-bottom: 20px;
    }
    .content {
      color: rgba(102, 102, 102, 0.65);
    }
  }
}
</style>
